<script setup lang="ts">
import { noticePopup } from '~/apis/common'
import type { NoticePopupResult } from '~/apis/common/type'

const route = useRoute()
const isVisible = ref(false)
const noticeData = ref<NoticePopupResult | null>(null)

const todayNoticeCookie = useCookie('todayNotice', {
  maxAge: 24 * 60 * 60, // 24시간
})

const checkCookie = () => {
  const savedDate = todayNoticeCookie.value
  const today = new Date().toDateString()

  // 저장된 날짜가 오늘과 같으면 팝업을 보여주지 않음
  if (savedDate === today) {
    isVisible.value = false
    return false
  }
  return true
}

const closePopup = (setTodayCookie = false) => {
  if (setTodayCookie) {
    // 오늘 날짜를 저장
    todayNoticeCookie.value = new Date().toDateString()
  }
  isVisible.value = false
}

// 팝업 데이터 조회
const getNoticePopup = async () => {
  try {
    const res = await noticePopup()
    if (res.data.code === '200') {
      noticeData.value = res.data.data[0] ?? {}
    }
  } catch (error) {
    console.log(error)
  }
}

onMounted(async () => {
  if (!route.path.includes('/print')) {
    // 쿠키 체크 후 팝업 표시 여부 결정
    isVisible.value = checkCookie()
    if (isVisible.value) {
      await getNoticePopup()
    }
  }
})
</script>

<template>
  <div
    v-if="isVisible && noticeData && !route.path.includes('/print')"
    class="noticePopup"
  >
    <div class="innner">
      <div class="close">
        <a @click="closePopup(false)"> 닫기 </a>
      </div>
      <main>
        <div class="img">
          <img
            :src="noticeData?.POPUP_IMAGE_URL"
            :alt="noticeData?.POPUP_TITLE"
          />
          <!--
          <img
            src="/assets/images/main/img_banner.png"
            alt="공지 팝업"
          />
          -->
        </div>
      </main>
      <div class="todayClose">
        <a @click="closePopup(true)"> 오늘 하루 보지 않기 </a>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
